import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

const titleMap = {
  design: "Design",
  sales: "Sales",
  audittraining: "Audit & Training",
  internalauditdashboard: "Internal Audit Dashboard",
  insurance: "Insurance",
  dispatch: "Dispatch",
  ppc1: "PPC-1",
  leadenquiry: "Lead & Enquiry Overview",
  recruitment: " HR Recruitment Analysis",
  attendance: "HR Attendance Analysis",
  purchase: "Purchase Analysis",
  looms: "Looms",
  tape: "Tape",
  itc4: "ITC-4",
  exlamination: "EX - Lamination",
  finishing1: "Finishing-1",
  finishing2: "Finishing-2",
  gravure: "Gravure",
};
const iframeMap = {
  design:
    "https://app.powerbi.com/view?r=eyJrIjoiZWUwZThkZTEtY2ZkNC00ODU0LTkwZWItMmY2YmRiZjdmYzU5IiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",

  sales:
    "https://app.powerbi.com/view?r=eyJrIjoiODg3N2FmNWUtMTI3NS00ODQyLTkzMzItMjZhYjRhNGFiMmFlIiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  audittraining:
    "https://app.powerbi.com/view?r=eyJrIjoiN2U2Yzc0YTQtZDQ4OC00NzgxLTgwOGYtMzliY2M0ZDZhYWM0IiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  internalauditdashboard:
    "https://app.powerbi.com/view?r=eyJrIjoiNjdjNzJlNGQtODIxOC00NjA4LTlhZDUtODQyYmQyZmI0MWExIiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  insurance:
    "https://app.powerbi.com/view?r=eyJrIjoiMTc2NmY1YzMtYTFmNi00YWRiLTg1MDktNTczNzllMmRjNWU2IiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  dispatch:
    "https://app.powerbi.com/view?r=eyJrIjoiZWQxM2EyMDctNTAzMi00N2Y2LWIwZTMtMWNhNWRmYTg4MWFkIiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  ppc1: "https://app.powerbi.com/view?r=eyJrIjoiNjVjMTVmODEtZGJlYy00YTA4LWE0NzMtZjFkODhkNmMyY2ViIiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  leadenquiry:
    "https://app.powerbi.com/view?r=eyJrIjoiMGU1MDk1ZDctY2M4NS00NGZjLWE4MGYtZTVkODU2MTk1MzI2IiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  recruitment:
    "https://app.powerbi.com/view?r=eyJrIjoiNDYxN2MyNDktMTVhOC00MmRjLTkxNmUtZDc3MjlmN2Q5MGE3IiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  attendance:
    "https://app.powerbi.com/view?r=eyJrIjoiN2Y2OTI2Y2UtZDliZC00NDZjLThkMjItZTgzODQ2MjExMzI0IiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  purchase:
    "https://app.powerbi.com/view?r=eyJrIjoiNzQwYzkwODItZjY3MS00NTMxLWFjMWMtODIxZDBmZjViN2RjIiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  looms: "https://app.powerbi.com/view?r=eyJrIjoiNDViOTM1MzQtZTNmYS00ZjdmLWFlMGQtOGQyYzIwOTY1Y2FmIiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  tape: "https://app.powerbi.com/view?r=eyJrIjoiMDFiMmRlZDgtNmMwNS00MzE2LThjZWItOTlhYzhjOWIyMTZkIiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  itc4: "https://app.powerbi.com/view?r=eyJrIjoiODE0OGYxMzktZDhlNy00Njc2LWE5NmMtMTI2MDg0MWUzYzM5IiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  exlamination:
    "https://app.powerbi.com/view?r=eyJrIjoiNDgyNDYwNjgtN2E5MS00YTY3LThjYjItNDQ0MjEwNGNmYmI0IiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  finishing1:
    "https://app.powerbi.com/view?r=eyJrIjoiNDFhZTU4ODctZjQ1NC00NTVjLWJjMmQtNjI0ZDVjMWZlMDkyIiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  finishing2:
    "https://app.powerbi.com/view?r=eyJrIjoiYTA2MzI4MmYtNjQ2Mi00Yjk1LThhYmQtM2Y0ZjhlZDRiMWZhIiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
  gravure:
    "https://app.powerbi.com/view?r=eyJrIjoiZmFhNDE3ZjQtNDFjYi00YzdmLTk0YjUtMTMyOThhMzZhZTE2IiwidCI6IjI4NDZlNzY1LTNmZjAtNDI5Yy04MzE3LWJjNTliODA5ZmQwNiJ9",
};

const MISReportPage = () => {
  const { reportName } = useParams();

  const userApps = useSelector(
    (state) => state.loginReducer.loginDetials.userApplications
  );

  const misApp =
    userApps?.find(
      (x) =>
        x.aP_Id === 14 || x.aP_Name.toLowerCase().includes("mis - dashboard")
    ) || {};

  const features = misApp.features || [];

  const normalize = (str = "") => str.toLowerCase().replace(/[^a-z0-9]/g, "");
  const normalizedReportName = normalize(reportName);
  const hasAccess = features.some((f) =>
    normalize(f.fT_Name).includes(normalize(normalizedReportName))
  );

  const iframeUrl = iframeMap[normalize(normalizedReportName)];

  return (
    <div className="dashboard app-content content">
      <div className="content-wrapper">
        <h5 className="text-info text-capitalize mb-2">
          <h5 className="text-info mb-2">
            {titleMap[normalizedReportName] || normalizedReportName} Report
          </h5>
        </h5>

        <div className="content-body card p-3">
          {hasAccess && iframeUrl ? (
            <iframe
              title={`${normalizedReportName} Report`}
              src={iframeUrl}
              width="100%"
              height="781.25"
              frameBorder="0"
              allowFullScreen="true"
            ></iframe>
          ) : (
            <h4 className="text-danger text-center mt-4">
              You do not have access to the {normalizedReportName} report.
            </h4>
          )}
        </div>
      </div>
    </div>
  );
};

export default MISReportPage;
